import React from "react";
import css from './PDFViewer.css'
import PropTypes from 'prop-types';

export default function PDFViewer(props) {

  return <div className={css.content}>
          <object data={props.url} type="application/pdf" width="100%" height="100%">
            {props.locale === "es" ?
              <p>Tu navegador no soporta PDFs. Por favor descarga el PDF para verlo: <a href={props.url}>Descargar PDF</a>.</p> :
              <p>Your browser doesn’t support PDFs. Please download the PDF to view it: <a href={props.url}>Download PDF</a>.</p>}
          </object>
        </div>
}

PDFViewer.propTypes = {
    locale: PropTypes.string,
    url: PropTypes.string
}
